import React from "react";
import { useSelector } from "react-redux";
import { Modal } from "antd";

import classes from "./Modal.module.css";
import CommonButton from "../Components/Buttons/CommonButton";

interface props {
  handleSuccess: () => void;
  itemName?: String;
  Delete?: boolean;
  open: boolean;
  closable: boolean;
  onCancel: () => void;
}

function LogoutconfirmationModal({
  handleSuccess,
  itemName,
  Delete = false,
  open,
  closable,
  onCancel,
}: props) {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const { loading } = useSelector((state: any) => state.Dashboard);

  return (
    <>
      {/* <Loader isLoader={loading} /> */}
      <Modal open={open} closable={closable} width={400} footer={null}>
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading}>
            {!Delete ? "Confirmation" : "Delete"}
          </h4>
          <div
            className={`${classes.sessionContentSec} w-100 `}
            style={{ textAlign: "center" }}
          >
            {!Delete && <p className="m-0">Hi user {LoginData?.userName}</p>}
            <p>
              Are you sure you want to {!Delete ? "logout" : "delete"}{" "}
              {itemName} ?
            </p>
          </div>
          <div
            className={`${classes.modal_button_container} justify-content-around`}
          >
            <CommonButton
              name="Yes"
              onClick={() => handleSuccess()}
              type="button"
              style={{
                maxWidth: "155px",
                height: "39px",
                padding: "9px 24px",
              }}
              classname="submit_btn"
            />
            <CommonButton
              name="No"
              onClick={() => onCancel()}
              type="No"
              style={{
                backgroundColor: "rgb(235, 49, 49)",
                maxWidth: 155,
                height: 39,
                padding: "9px 24px",
              }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default LogoutconfirmationModal;
